module.exports = __webpack_public_path__ + "img/sub4_step8.0658ce06.png";